module.exports = __webpack_public_path__ + "static/img/13.ec24c6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/13.png
// module id = yZwE
// module chunks = 1